import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LoginLinkSuccessModal } from "@/pages/Login/components/LoginLinkSuccessModal";

type LoginLinkSuccessQueryParams = {
  redirect: string | undefined;
  email: string;
};

export const Route = createFileRoute("/login-link-modal")({
  component: LoginLinkSuccessPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): LoginLinkSuccessQueryParams => ({
    redirect:
      typeof search?.redirect === "string" ? search?.redirect : undefined,
    email: typeof search?.email === "string" ? search?.email : "",
  }),
});

function LoginLinkSuccessPage() {
  const { email } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <LoginLinkSuccessModal
      email={email}
      open
      onClose={() =>
        navigate({
          to: "/home",
          search: { redirect: undefined, downloadJobId: undefined },
        })
      }
    />
  );
}
